import { render, staticRenderFns } from "./ChatRecoveryLoader.vue?vue&type=template&id=ca20f8ce&scoped=true&"
import script from "./ChatRecoveryLoader.vue?vue&type=script&lang=js&"
export * from "./ChatRecoveryLoader.vue?vue&type=script&lang=js&"
import style0 from "./ChatRecoveryLoader.vue?vue&type=style&index=0&id=ca20f8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca20f8ce",
  null
  
)

export default component.exports